import React from 'react';
import { connect } from '@cerebral/react';
import { signal } from 'cerebral/tags';

import View from '../components/View';
import { CdnContext } from '../context';

class PartIntro extends React.Component {
    componentDidMount() {
        const { trackEvent, slug } = this.props;
        trackEvent({
            eventAction: 'part_started',
            eventProperties: {
                event_label: slug,
            },
        });
    }
    render() {
        const {
            part,
            amount,
            title,
            slug,
            description,
            quote,
            sections,
        } = this.props;
        return (
            <View>
                <div className="page page-part-intro">
                    <CdnContext.Consumer>
                        {cdn => (
                            <div className="splitview">
                                <div className="split-left">
                                    <img
                                        src={`${cdn}assets/images/quotes/quote_chapter${part}@2x.png`}
                                        alt=""
                                        className="open-quote"
                                    />
                                    {/* <img
                                        src={`${cdn}assets/images/personen/chapter${part}@2x.png`}
                                        alt=""
                                        className="quote-img"
                                    /> */}
                                    <p className="part-quote">{quote}</p>
                                </div>
                                <div className="split-right">
                                    <h6 className="sub-heading">
                                Deel {part} van {amount}
                                    </h6>
                                    <h1 className="heading">{title}</h1>
                                    <div className="description">
                                        <p
                                            // eslint-disable-next-line
                                    dangerouslySetInnerHTML={{
                                                __html: description,
                                            }}
                                        />
                                    </div>
                                    <a
                                        href={`#/${slug}/${sections[0].slug}`}
                                        className="btn btn-primary"
                                    >
                                Start{' '}
                                        <i className="bol-icon-icon_arrow_right" />
                                    </a>
                                </div>
                            </div>
                        )}
                    </CdnContext.Consumer>
                </div>
            </View>
        );
    }
}
const stateSignal = {
    trackEvent: signal`app.trackEvent`,
};

export default connect(
    stateSignal,
    PartIntro
);



// WEBPACK FOOTER //
// ./src/pages/PartIntro.js